import * as React from "react";
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { Table, Col, Row } from "react-bootstrap";
import { RespuestaGestionGlosas } from "../modelo/GlosaEmpleador";
import icoSura from "../../../../../../assets/img/ico-sura-modal.png";
import { obtenerProcesoGestion } from "../modelo/TiposProcesosGestion";

export class ModalRespuestaGestionGlosas extends React.Component<ModalRespuestaGestionGlosasProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: true
        };
    }

    handleShow() {
        this.setState({show: true});
    }
    
    handleClose() {
        this.setState({show: false});
        this.props.cerrarModalRespuestaGestionGlosas();
    }

    render() {
        return(
            <div>
                {this.renderModalRespuestaGestionGlosas()}
            </div>
        );
    }

    renderModalRespuestaGestionGlosas() {
        const btnAcciones = [
            (
                <FlatButton key={0}
                            label="Cerrar"
                            onClick={() => this.handleClose()}/>
            )
        ];
        return(
            <div>
                <Dialog title={this.rendeEncabezadoModal()}
                        actions={btnAcciones}
                        contentStyle={{width: '75%', maxWidth: 'none'}}
                        open={this.state.show}
                        onRequestClose={() => this.handleClose()}
                        modal={false}
                        autoScrollBodyContent>
                    {this.renderContenidoGestionGlosas()}
                </Dialog>
            </div>
        );
    }

    rendeEncabezadoModal() {
        return (
            <div>
                <Row>
                    <Col sm={6}>
                        {"Gestión de Glosas SAT"}
                    </Col>
                    <Col smOffset={4} sm={2}>
                        <img src={icoSura}/>
                    </Col>
                </Row>
            </div>
        );
    }
    
    renderContenidoGestionGlosas() {
        return(
            <div>
                <div className="modal-form-text">
                    <label><b>Errores proceso de gestión de glosas</b></label>
                    {
                        this.props.dniUsuarioGestionLogin && 
                        <div className="subtitle-modal">Usuario Gestión {this.props.dniUsuarioGestionLogin}</div>
                    }
                    <Divider/>
                    <br/>
                </div>
                <div>
                    {this.renderTablaRespuestaGestionGlosas()}
                </div>
            </div>
        );
    }

    renderTablaRespuestaGestionGlosas() {
        const {listaRespuestaGestionGlosas, esAfiliacionTraslado} = this.props;
        return(
            <Table responsive striped bordered condensed hover>
                <thead>
                    <tr>
                        <th><b>#</b></th>
                        <th><b>{esAfiliacionTraslado ? 'DNI' : 'Póliza'}</b></th>
                        <th><b>Transacción</b></th>
                        <th><b>Servicio</b></th>
                        <th><b>Consecutivo</b></th>
                        <th><b>Glosa</b></th>
                        <th><b>Proceso</b></th>
                        <th><b>Error</b></th>
                        <th><b>Descripción Error</b></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listaRespuestaGestionGlosas.filter((respuesta) => !respuesta.exitoGestion).map( (respuestaGestionGlosas: RespuestaGestionGlosas, index) => (
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{esAfiliacionTraslado ? respuestaGestionGlosas.glosaEmpleador.dniEmpleador : respuestaGestionGlosas.glosaEmpleador.npoliza}</td>
                                <td>{this.props.obtenerNombreTipoTransaccion(respuestaGestionGlosas.glosaEmpleador.codigoServicio)}</td>
                                <td>{respuestaGestionGlosas.glosaEmpleador.codigoServicio}</td>
                                <td>{respuestaGestionGlosas.glosaEmpleador.consecutivo}</td>
                                <td>{respuestaGestionGlosas.glosaEmpleador.codigoGlosa}</td>
                                <td>{obtenerProcesoGestion(respuestaGestionGlosas.codigoProceso).nombreProceso}</td>
                                <td><b>{respuestaGestionGlosas.codigoRespuesta}</b></td>
                                <td><b>{respuestaGestionGlosas.mensajeRespuesta}</b></td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        );
    }
    
}

interface ModalRespuestaGestionGlosasProps {
    listaRespuestaGestionGlosas: Array<RespuestaGestionGlosas>,
    dniUsuarioGestionLogin?: string,
    esAfiliacionTraslado?: boolean,
    cerrarModalRespuestaGestionGlosas: () => void,
    obtenerNombreTipoTransaccion?: (codigo: number) => string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/ModalRespuestaGestionGlosas.tsx